import React, { useContext, useState } from 'react';
import { format as formatDate } from 'date-fns';

import { CalendarContext } from '../../context/CalendarContext.jsx';

function FilterRangeSwitch() {
  const [index, setIndex] = useState(0);
  const { config, filter, updateFilter } = useContext(CalendarContext);

  const handleUpdate = (i, from, to) => {
    const newRange = {
      from,
      to
    };

    setIndex(i);
    updateFilter((prev) => ({ ...prev, dateSwitch: { ...prev.dateSwitch, ...newRange } }));
  };

  const formatCurrentDate = (from, to) =>
    `${formatDate(from, config.date.format || 'dd.MM.yyyy')} – ${formatDate(to, config.date.format || 'dd.MM.yyyy')}`;

  return (
    <div className="filter-range-switch">
      {filter.dateSwitch.items.map((item, i) => (
        <button
          key={item.from}
          type="button"
          className={`text text--small-link ${index === i ? 'is-selected' : ''}`}
          onClick={() => handleUpdate(i, item.from, item.to)}
        >
          {formatCurrentDate(item.from, item.to)}
        </button>
      ))}
    </div>
  );
}

export default FilterRangeSwitch;
